<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label required">{{
                  $t('studentPerformance.mainProgram')
                }}</label>
                <a-select
                  style="width: 100%"
                  v-model.number="model.acp_id"
                  :options="main_programs"
                  :show-search="true"
                  :filter-option="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  @change="onMainProgramChange"
                ></a-select>
                <div class="validate" v-if="errors.has('acps_id')">
                  {{ errors.first('acps_id') }}
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label required">{{
                  $t('studentPerformance.subProgram')
                }}</label>
                <a-select
                  style="width: 100%"
                  v-model.number="model.acps_id"
                  :options="sub_programs"
                  :show-search="true"
                  :filter-option="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  @change="onSubChange"
                  :disabled="!model.acp_id"
                ></a-select>
                <div class="validate" v-if="errors.has('acps_id')">
                  {{ errors.first('acps_id') }}
                </div>
              </div>
              <div>
                <label class="form-label required">{{
                  $t('studentPerformance.acYear')
                }}</label>
                <a-select
                  style="width: 100%"
                  v-model.number="model.ac_year_id"
                  :options="ac_year_list"
                  :loading="fetching_academic_year"
                  @change="acYearChange"
                ></a-select>
                <div class="validate" v-if="errors.has('ac_year_id')">
                  {{ errors.first('ac_year_id') }}
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label required">{{
                  $t('studentPerformance.acTerm')
                }}</label>
                <a-select
                  style="width: 100%"
                  v-model.number="model.ac_term_id"
                  :options="acTerms"
                  :show-search="true"
                  :loading="fetching_academic_term"
                  :filter-option="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  @change="acTermChange"
                ></a-select>
                <div class="validate" v-if="errors.has('ac_term_id')">
                  {{ errors.first('ac_term_id') }}
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label required">{{
                  $t('studentPerformance.classOperation')
                }}</label>
                <a-select
                  style="width: 100%"
                  v-model="model.class_id"
                  :options="class_options"
                  :show-search="true"
                  :placeholder="$t('all')"
                  :loading="fetching_class_operation"
                  :filter-option="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  @change="classChange"
                ></a-select>
                <div class="validate" v-if="errors.has('class_id')">
                  {{ errors.first('class_id') }}
                </div>
              </div>
              <div>
                <label class="form-label">{{
                  $t('studentPerformance.subject')
                }}</label>
                <a-select
                  style="width: 100%"
                  v-model="model.subject_id"
                  :options="subjects"
                  :show-search="true"
                  :maxTagCount="2"
                  :placeholder="$t('all')"
                  mode="multiple"
                  :filter-option="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                ></a-select>
                <div class="validate" v-if="errors.has('subject_id')">
                  {{ errors.first('subject_id') }}
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label required">{{
                  $t('studentPerformance.scoringCycle')
                }}</label>
                <a-select
                  style="width: 100%"
                  v-model="model.scoring_cycle_id"
                  :options="scoringCycles"
                  @change="scoringCycleChange"
                >
                </a-select>
                <div class="validate" v-if="errors.has('scoring_cycle_id')">
                  {{ errors.first('scoring_cycle_id') }}
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label required">{{
                  $t('studentPerformance.cycleValue')
                }}</label>
                <a-select
                  style="width: 100%"
                  v-model="model.cycle_value"
                  :disabled="reportType"
                  :options="scoringCycleValues"
                >
                </a-select>
                <div class="validate" v-if="errors.has('cycle_value')">
                  {{ errors.first('cycle_value') }}
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label"></label>
                <ts-button
                  class="btn-block"
                  color="primary"
                  @click.prevent="preview"
                  :waiting="waiting"
                  >{{ $t('preview') }}</ts-button
                >
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import { includes } from 'lodash'

export default {
  name: 'filter',
  data() {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      fetching_academic_year: false,
      fetching_academic_term: false,
      fetching_class_operation: false,
      fetching_student: false,
      src: '',
      errors: new Errors(),
      branches: [],
      scoringCycle: [],
      scoringCycleValue: [],
      ac_year_list: [],
      main_programs: [],
      sub_programs: [],
      ac_terms: [],
      class_options: [],
      subjects: [],
      grade: [],
      term_order: null,
      model: {
        scoring_cycle_id: null,
        branch_id: null,
        ac_year_id: null,
        ac_term_id: null,
        acp_id: null,
        acps_id: null,
        class_id: null,
        grade_id: null,
        cycle_value: null,
        subject_id: [],
        teacher_id: null
      }
    }
  },
  computed: {
    scoringCycles() {
      if (this.model.acps_id) {
        let scoring_cyles = this.sub_programs.find(
          el => el.value == this.model.acps_id
        ).scoring_cyles
        if (this.term_order < 2) {
          return this.scoringCycle
            .filter(el => includes(scoring_cyles, el.value))
            .filter(el => el.value != 4)
        }
        return this.scoringCycle.filter(el => includes(scoring_cyles, el.value))
      }
      return this.scoringCycle
    },
    grades() {
      return this.grade
    },
    reportType() {
      if (
        this.model.scoring_cycle_id == 5 ||
        this.model.scoring_cycle_id == 1 ||
        this.model.scoring_cycle_id == 7
      ) {
        return false
      }
      return true
    },
    scoringCycleValues() {
      if (this.model.scoring_cycle_id) {
        // Termly For ELT
        if (this.model.scoring_cycle_id == 7 && this.model.ac_term_id) {
          return this.scoringCycleValue
            .filter(s => s.scoring_cycle_id == this.model.scoring_cycle_id)
            .filter(el =>
              includes(this.term_order == 1 ? [1, 2] : [3, 4, 5], el.value)
            )
        }
        // Unit For ELT
        if (this.model.scoring_cycle_id == 5 && this.model.ac_term_id) {
          return this.scoringCycleValue
            .filter(s => s.scoring_cycle_id == this.model.scoring_cycle_id)
            .filter(el =>
              includes(this.term_order == 1 ? [1, 2, 3] : [4, 5, 6], el.value)
            )
        }
        return this.scoringCycleValue.filter(
          s => s.scoring_cycle_id == this.model.scoring_cycle_id
        )
      }
      return this.scoringCycleValue
    },
    acTerms() {
      // For AIA 1 year has 2 semester
      // scoring_cycle_id = 4 is for yearly cycle
      // term order = 2 is for semester 2
      if (this.model.scoring_cycle_id == 4) {
        return this.ac_terms.filter(s => s.term_order == 2) // yealy report get class operation on semester 2 or end of year
      }
      return this.ac_terms
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportAcademic', [
      'studentPerformance',
      'getBranch',
      'getYear',
      'getMainProgram',
      'getSubProgram',
      'getTerm',
      'getClass',
      'getScoringCycle',
      'getScoringCycleValue',
      'getGrade'
    ]),
    // Fetch Data
    async fetchData() {
      this.loading = true
      await this.getBranch().then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
      })
      await this.getMainProgram()
        .then(response => {
          this.main_programs = response.data
            // .filter(mp => mp.acp_id == 101) // acp_id = 102 is English program in ASEAN
            .map(el => ({
              value: el.acp_id,
              label: el.acp_name_foreign
            }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
          this.model.branch_id = this.$store.state.authUser.default_branch_id
          this.model.acp_id = this.main_programs[0].value
          if (this.model.acp_id) {
            this.getSubProgram({
              filter: {
                acp_id: this.model.acp_id
              }
            })
              .then(response => {
                this.sub_programs = response.data.map(el => ({
                  value: el.acps_id,
                  label: el.acps_name_foreign,
                  scoring_cyles: el.scoring_cyles.map(el => el.scoring_cycle_id)
                }))
              })
              .catch(error => {
                this.$toasted.error(error.message)
              })
              .finally(() => {
                this.loading = false
                this.model.acps_id = this.sub_programs[0].value
                if (this.model.acps_id) {
                  this.getTerm({
                    filter: {
                      acps_id: this.model.acps_id,
                      ac_year_id: this.model.ac_year_id,
                      branch_id: this.model.branch_id,
                      ac_status_id: '1,2,3'
                    }
                  })
                    .then(response => {
                      this.ac_terms = response.data.map(el => ({
                        value: el.ac_term_id,
                        ac_status_id: el.ac_status_id,
                        term_order: el.term_order,
                        label:
                          el.term_name +
                          (el.ac_status_id == 1
                            ? ' ( Current ) '
                            : el.ac_status_id == 2
                            ? ' ( History ) '
                            : '( Next )')
                      }))
                    })
                    .catch(error => {
                      this.$toasted.error(error.message)
                    })
                    .finally(() => {
                      this.loading = false
                      this.ac_terms
                        .filter(el => el.ac_status_id == 1)
                        .map(el => (this.model.ac_term_id = el.value))
                      if (this.model.ac_term_id) {
                        this.getClass({
                          filter: {
                            ac_term_id: this.model.ac_term_id,
                            branch_id: this.model.branch_id
                          }
                        })
                          .then(response => {
                            this.class_options = response.data.map(el => ({
                              value: el.class_id,
                              label:
                                el.class_name +
                                ' | ' +
                                el.teacher.full_name_en +
                                ' | ' +
                                el.academic_study_time.study_time,
                              grade_id: el.grade_id
                            }))
                          })
                          .catch(error => {
                            this.$toasted.error(error.message)
                          })
                          .finally(() => {
                            this.fetching_class_operation = false
                            if (this.class_options.length > 0) {
                              this.model.class_id = this.class_options[0].value
                              this.model.grade_id = this.class_options[0].grade_id
                            }
                            if (this.model.class_id) {
                              this.$store
                                .dispatch(
                                  'subjectGradingRange/getSubject',
                                  this.model.grade_id
                                )
                                .then(response => {
                                  if (response.data[0].grade_subjects != null) {
                                    this.subjects = response.data[0].grade_subjects.map(
                                      el => ({
                                        value: el.subject_id,
                                        label:
                                          el.subject_name_native +
                                          ' ' +
                                          el.subject_name_foreign
                                      })
                                    )
                                  }

                                  // this.selectedSubjectId.id.push(
                                  //   ...this.subjects.map(el => el.value)
                                  // )
                                })
                                .catch(error => {
                                  this.$toasted.error(error.message)
                                })
                                .finally(() => {
                                  this.loading = false
                                })
                            }
                          })
                      }
                    })
                  this.getScoringCycle({
                    acps_id: this.model.acps_id
                  })
                    .then(response => {
                      this.scoringCycle = response.data.map(el => ({
                        value: el.scoring_cycle_id,
                        label: el.scoring_cycle_name
                      }))
                    })
                    .catch(error => {
                      this.$toasted.error(error.message)
                    })
                    .finally(() => {
                      this.loading = false
                      this.model.scoring_cycle_id = this.scoringCycle[0].value
                      if (
                        this.model.scoring_cycle_id == 0 ||
                        this.model.scoring_cycle_id == 2 ||
                        this.model.scoring_cycle_id == 3 ||
                        this.model.scoring_cycle_id == 6
                      ) {
                        this.getScoringCycleValue({
                          scoring_cycle_id: this.model.scoring_cycle_id
                        })
                          .then(response => {
                            this.scoringCycleValue = response.data.map(el => ({
                              value: el.scoring_cycle_value,
                              label: el.scoring_cycle_description,
                              scoring_cycle_id: el.scoring_cycle_id
                            }))
                          })
                          .catch(error => {
                            this.$toasted.error(error.message)
                          })
                          .finally(() => {
                            this.loading = false
                            this.model.cycle_value = this.ac_terms.find(
                              el => el.value == this.model.ac_term_id
                            ).term_order
                          })
                      } else {
                        this.getScoringCycleValue({
                          scoring_cycle_id: this.model.scoring_cycle_id
                        })
                          .then(response => {
                            this.scoringCycleValue = response.data.map(el => ({
                              value: el.scoring_cycle_value,
                              label: el.scoring_cycle_description,
                              scoring_cycle_id: el.scoring_cycle_id
                            }))
                          })
                          .catch(error => {
                            this.$toasted.error(error.message)
                          })
                          .finally(() => {
                            this.loading = false
                            this.model.cycle_value = this.scoringCycleValue[0].value
                          })
                      }
                    })
                }
              })
          }
          if (this.model.branch_id) {
            this.getYear({
              filter: {
                branch_id: this.model.branch_id,
                ac_status_id: '1,2,3'
              }
            })
              .then(response => {
                this.ac_year_list = response.data.map(el => ({
                  value: el.ac_year_id,
                  ac_status_id: el.ac_status_id,
                  label:
                    el.ac_year +
                    (el.ac_status_id == 1
                      ? ' ( Current ) '
                      : el.ac_status_id == 2
                      ? ' ( History ) '
                      : ' ( Next ) ')
                }))
              })
              .catch(error => {
                this.$toasted.error(error.message)
              })
              .finally(() => {
                this.loading = false
                this.ac_year_list
                  .filter(el => el.ac_status_id == 1)
                  .map(el => (this.model.ac_year_id = el.value))
              })
          }
        })
    },
    //onChange branch
    onBranchChange() {
      this.model.ac_year_id = null
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.fetching_academic_year = true
      this.getYear({
        filter: {
          ac_status_id: '1,2,3',
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
            el => ({
              value: el.ac_year_id,
              label:
                el.ac_year +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : ' ( Next ) ')
            })
          )
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_academic_year = false
        })
    },
    //onMainProgramChange
    async onMainProgramChange(acp_id) {
      this.model.acps_id = null
      await this.getSubProgram({
        filter: {
          acp_id: acp_id
        }
      })
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign,
            scoring_cyles: el.scoring_cyles.map(el => el.scoring_cycle_id)
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    //onSubChange
    onSubChange(acps_id) {
      this.model.ac_term_id = null
      this.model.class_id = null
      if (this.model.ac_year_id) {
        this.fetching_academic_term = true
        this.getTerm({
          filter: {
            acps_id: acps_id,
            ac_status_id: '1,2,3',
            ac_year_id: this.model.ac_year_id,
            branch_id: this.model.branch_id
          },
          branch_id: [this.model.branch_id]
        })
          .then(response => {
            this.ac_terms = response.data.map(el => ({
              value: el.ac_term_id,
              term_order: el.term_order,
              label:
                el.term_name +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : '( Next )')
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.fetching_academic_term = false
          })
      }

      this.getScoringCycle({ acps_id: acps_id })
        .then(response => {
          this.scoringCycle = response.data.map(el => ({
            value: el.scoring_cycle_id,
            label: el.scoring_cycle_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    //acYearChange
    acYearChange() {
      // this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.class_id = null
      this.model.subject_id = undefined
      this.fetching_academic_term = true
      this.getTerm({
        filter: {
          acps_id: this.model.acps_id,
          ac_status_id: '1,2,3',
          ac_year_id: this.model.ac_year_id,
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.ac_terms = response.data.map(el => ({
            value: el.ac_term_id,
            term_order: el.term_order,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : '( Next )')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_academic_term = false
        })
    },
    //acTermChange
    acTermChange(ac_term_id) {
      //For Asean get cycle_value
      if (
        this.model.scoring_cycle_id == 0 ||
        this.model.scoring_cycle_id == 2 ||
        this.model.scoring_cycle_id == 3 ||
        this.model.scoring_cycle_id == 6
      ) {
        this.model.cycle_value = this.ac_terms.find(
          el => el.value == this.model.ac_term_id
        ).term_order
      } else {
        this.model.cycle_value = null
      }
      this.term_order = this.ac_terms.find(
        el => el.value == this.model.ac_term_id
      ).term_order
      this.fetching_class_operation = true
      this.model.class_id = null
      this.getClass({
        filter: {
          ac_term_id: ac_term_id,
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.class_options = response.data.map(el => ({
            value: el.class_id,
            label:
              el.class_name +
              ' | ' +
              el.teacher.full_name_en +
              ' | ' +
              el.academic_study_time.study_time,
            grade_id: el.grade_id,
            teacher_id: el.teacher_resp_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_class_operation = false
        })
    },
    // scoringCycleChange
    async scoringCycleChange(scoring_cycle_id) {
      await this.getScoringCycleValue({ scoring_cycle_id: scoring_cycle_id })
        .then(response => {
          this.scoringCycleValue = response.data.map(el => ({
            value: el.scoring_cycle_value,
            label: el.scoring_cycle_description,
            scoring_cycle_id: el.scoring_cycle_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      if (
        this.model.scoring_cycle_id == 0 ||
        this.model.scoring_cycle_id == 2 ||
        this.model.scoring_cycle_id == 3 ||
        this.model.scoring_cycle_id == 6
      ) {
        this.model.cycle_value = this.ac_terms.find(
          el => el.value == this.model.ac_term_id
        ).term_order
      } else {
        this.model.cycle_value = null
      }
    },
    //classChange
    classChange() {
      this.model.subject_id = undefined
      this.fetching_student = true
      this.getGrades()
      this.$store
        .dispatch('subjectGradingRange/getSubject', this.model.grade_id)
        .then(response => {
          if (response.data[0].grade_subjects != null) {
            this.subjects = response.data[0].grade_subjects.map(el => ({
              value: el.subject_id,
              label: el.subject_name_native + ' ' + el.subject_name_foreign
            }))
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_student = false
        })
    },
    // get grade by class room
    getGrades() {
      let classOperation = this.class_options.find(
        el => el.value == this.model.class_id
      )

      this.model.grade_id = classOperation.grade_id
      this.model.teacher_id = classOperation.teacher_id
    },
    preview() {
      this.waiting = true
      this.$emit('waiting', this.waiting)
      this.src = ''
      this.errors = new Errors()
      this.studentPerformance(this.model)
        .then(response => {
          this.$emit('collection-data', response)
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.$emit('collection-data', null)
        })
        .finally(() => {
          this.waiting = false
          this.$emit('waiting', this.waiting)
        })
    }
  }
}
</script>

<style scoped>
label {
  margin-bottom: 0.2rem;
}
</style>
